module.exports = __webpack_public_path__ + "static/media/73.6358ec5d.jpg";